import initNav from "./components/nav.js";
import initStickyNav from "./components/nav-sticky.js";
import initHero from "./components/hero.js";
import initIntro from "./components/intro.js";
import initFeatureHighlights from "./components/feature-highlights.js";

document.addEventListener("DOMContentLoaded", () => {
  initNav();
  initStickyNav();
  initHero();
  initIntro();
  initFeatureHighlights();
});
